var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 41,
    viewBox: "0 0 20 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_975_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6698 9.82604L9.33021 8.73437C9.12604 8.63958 8.95833 8.74583 8.95833 8.97187V11.0281C8.95833 11.2542 9.12604 11.3604 9.33021 11.2656L11.6688 10.174C11.874 10.0781 11.874 9.92188 11.6698 9.82604ZM10 0C4.47708 0 0 4.47708 0 10C0 15.5229 4.47708 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47708 15.5229 0 10 0ZM10 14.0625C4.88125 14.0625 4.79167 13.601 4.79167 10C4.79167 6.39896 4.88125 5.9375 10 5.9375C15.1187 5.9375 15.2083 6.39896 15.2083 10C15.2083 13.601 15.1187 14.0625 10 14.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6698 30.826L9.33021 29.7344C9.12604 29.6396 8.95833 29.7458 8.95833 29.9719V32.0281C8.95833 32.2542 9.12604 32.3604 9.33021 32.2656L11.6688 31.174C11.874 31.0781 11.874 30.9219 11.6698 30.826ZM10 21C4.47708 21 0 25.4771 0 31C0 36.5229 4.47708 41 10 41C15.5229 41 20 36.5229 20 31C20 25.4771 15.5229 21 10 21ZM10 35.0625C4.88125 35.0625 4.79167 34.601 4.79167 31C4.79167 27.399 4.88125 26.9375 10 26.9375C15.1187 26.9375 15.2083 27.399 15.2083 31C15.2083 34.601 15.1187 35.0625 10 35.0625Z",
    fill: "#F73759"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_975_1143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.553ec7fa3592c46898fc93c6e88666e3.svg";
export { ForwardRef as ReactComponent };